module.exports = __webpack_public_path__ + "static/src/content/images/processed/thumb/Alien3.0b02b60.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/thumb/Alien3.jpg
// module id = 6m3F
// module chunks = 0